const LANGUAGE_TAGS = [
  { value: 'sq-AL', label: 'Albanian Albania' },
  { value: 'ar-EG', label: 'Arabic Egypt' },
  { value: 'ar-SA', label: 'Arabic Saudi Arabia' },
  { value: 'ar-XA', label: 'Arabic Modern Standard' },
  { value: 'cs-CZ', label: 'Czech Czech Republic' },
  { value: 'hr-HR', label: 'Croatian Croatia' },
  { value: 'da-DK', label: 'Danish Denmark' },
  { value: 'de-DE', label: 'German Germany' },
  { value: 'el-GR', label: 'Modern Greek Greece' },
  { value: 'en-AU', label: 'English Australia' },
  { value: 'en-GB', label: 'English United Kingdom' },
  { value: 'en-IE', label: 'English Ireland' },
  { value: 'en-US', label: 'English United States' },
  { value: 'en-ZA', label: 'English South Africa' },
  { value: 'es-ES', label: 'Spanish Spain' },
  { value: 'es-MX', label: 'Spanish Mexico' },
  { value: 'es-PE', label: 'Spanish Peru' },
  { value: 'es-CL', label: 'Spanish Chile' },
  { value: 'fi-FI', label: 'Finnish Finland' },
  { value: 'fr-CA', label: 'French Canada' },
  { value: 'fr-FR', label: 'French France' },
  { value: 'he-IL', label: 'Hebrew Israel' },
  { value: 'hi-IN', label: 'Hindi India' },
  { value: 'hu-HU', label: 'Hungarian Hungary' },
  { value: 'id-ID', label: 'Indonesian Indonesia' },
  { value: 'it-IT', label: 'Italian Italy' },
  { value: 'ja-JP', label: 'Japanese Japan' },
  { value: 'ko-KR', label: 'Korean Republic of Korea' },
  { value: 'nl-BE', label: 'Dutch Belgium' },
  { value: 'nl-NL', label: 'Dutch Netherlands' },
  { value: 'no-NO', label: 'Norwegian Norway' },
  { value: 'pl-PL', label: 'Polish Poland' },
  { value: 'pt-BR', label: 'Portuguese Brazil' },
  { value: 'pt-PT', label: 'Portuguese Portugal' },
  { value: 'ro-RO', label: 'Romanian Romania' },
  { value: 'ru-RU', label: 'Russian Russian Federation' },
  { value: 'sk-SK', label: 'Slovak Slovakia' },
  { value: 'sv-SE', label: 'Swedish Sweden' },
  { value: 'th-TH', label: 'Thai Thailand' },
  { value: 'tr-TR', label: 'Turkish Turkey' },
  { value: 'zh-CN', label: 'Chinese China' },
  { value: 'zh-HK', label: 'Chinese Hong Kong' },
  { value: 'zh-TW', label: 'Chinese Taiwan' },
];

export default LANGUAGE_TAGS;
